<script setup lang="ts" generic="F extends Record<string, unknown>">
import { PV } from "@/widgets";
import type { FilterController } from "../filter";

const props = defineProps<{
    controller: FilterController<F>;
}>();

const emits = defineEmits<{
    toggleFilterPopup: [Event];
}>();
</script>

<template>
    <PV.OverlayBadge
        v-if="props.controller.selectedCount.value > 0 || props.controller.applicable.value"
        :severity="props.controller.applicable.value ? 'contrast' : 'primary'"
        size="small"
        :value="props.controller.selectedCount.value"
    >
        <PV.Button
            class="shadow-xs"
            icon="pi pi-filter"
            outlined
            severity="secondary"
            size="small"
            @click="(e) => emits('toggleFilterPopup', e)"
        />
    </PV.OverlayBadge>
    <PV.Button
        v-else
        icon="pi pi-filter"
        severity="secondary"
        size="small"
        text
        @click="(e) => emits('toggleFilterPopup', e)"
    />
</template>
